<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- ime -->
      <div class="columns">
        <div class="column">
          <input
            class="input has-text-centered has-background-info-light"
            type="text"
            placeholder="Naziv"
            v-model="selectedShift.name"
          />
        </div>
      </div>
      <!-- opis -->
      <div class="columns">
        <div class="column">
          <input
            class="input has-text-centered has-background-info-light"
            type="text"
            placeholder="opis"
            v-model="selectedShift.description"
          />
        </div>
      </div>
      <!-- Startno i završno vrijeme -->
      <div class="columns">
        <!-- Startno vrijeme -->
        <div class="column">
          <date-picker
            v-model="selectedShift.startTime"
            type="time"
            placeholder="Početak"
          ></date-picker>
        </div>
        <!-- Završno vrijeme -->
        <div class="column">
          <date-picker
            v-model="selectedShift.endTime"
            type="time"
            placeholder="Kraj"
          ></date-picker>
        </div>
      </div>
      <!-- Is start time fixed -->
      <div class="column">
        <div class="has-text-centered">
          <label>Da li je start fiksan?</label>
        </div>
        <div class="is-four-fifths">
          <input
            class="
              has-text-weight-bold has-text-centered has-background-info-light
            "
            type="checkbox"
            v-model="selectedShift.isStartTimeFixed"
          />
        </div>
      </div>
      <!-- Kompleksno radno vrijeme -->
      <!-- <div class="columns">
        <div class="column has-text-centered">
          <label>Kompleksno radno vrijeme</label>
        </div>
        <div class="column has-text-centered is-four-fifths"></div>
      </div> -->
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "EditShift",

  components: {
    DatePicker,
  },

  props: {
    button1Name: String,
    button2Name: String,
    title: String,
    selectedShift: Object,
    departments: Array,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {};
  },
  mounted() {
    console.log("mounted");
    this.selectedShift.companyId = this.$store.state.general.companyId;
  },
  methods: {
    saveAndProceedButtonClicked() {
      this.$emit("saveAndProceedClicked", this.selectedShift);
      console.log(this.selectedShift);
    },
    saveAndCloseButtonClicked() {
      this.$emit("saveAndCloseClicked", this.selectedShift);
      console.log(this.selectedShift);
    },
  },
};
</script>
